import React from 'react'
import { connect } from 'react-redux'

import FAQ from '../components/FAQ'
import { fetchFAQs, clearFAQMessages } from '../actions/faqActions'
import { fetchFAQCategories, clearFAQCategoryMessages } from '../actions/faqCategoryActions'
import { userHasFunctionality } from '../../../../utils/userUtils'

import '../style/faq.scss'

class FAQContainer extends React.Component {
  componentWillMount() {
    if (!this.props.faqCategories) {
      this.props.fetchFAQCategories()
    }
  }

  componentWillUnmount() {
    this.props.clearFAQMessages()
    this.props.clearFAQCategoryMessages()
  }

  render() {
    return <FAQ {...this.props} />
  }
}

const mapStateToProps = state => ({
  ...state.faqState,
  ...state.faqCategoryState,
  helpTicketUrlLoggedInInternal: state.serverProperties?.helpTicketUrlLoggedInInternal,
  helpTicketUrlLoggedInExternal: state.serverProperties?.helpTicketUrlLoggedInExternal,
  helpTicketUrlLoggedOutExternal: state.serverProperties?.helpTicketUrlLoggedOutExternal,
  helpTicketUrlAnonymous: state.serverProperties?.helpTicketUrlAnonymous,
  isCsmEnabled: state.serverProperties?.isCsmEnabled === 'true',
  isCsmEnabledForAnonymousUsers: state.serverProperties?.isCsmEnabledForAnonymousUsers === 'true',
  userCanEditFAQ: userHasFunctionality(state.currentUser, 'Edit FAQ'),
  userIsLoggedIn: !!(state?.currentUser?.registered),
  userIsAffiliate: !!(state?.currentUser?.isAffiliate)
})

const mapDispatchToProps = { fetchFAQs, fetchFAQCategories, clearFAQMessages, clearFAQCategoryMessages }

export default connect(mapStateToProps, mapDispatchToProps)(FAQContainer)